export default "__VITE_ASSET__b3e6ae22__"